import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Input } from 'reactstrap'
import Spinner from '../Spinner/Spinner.js'
import { STATES_QUERY } from '../../graphql.js'
import { handleGraphQLErrors } from '../../utils'

export const STATES = gql(STATES_QUERY)

export default function StateInput(props) {
  const { tenant, multiple, handleChange, defaultValue } = props
  console.log('StateInput rendered', props)

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: STATES, variables: { tenant: tenant }, fetchPolicy: 'cache-first' })
        if (data.states) {
          const menuItems = []
          if (!multiple) {
            menuItems.push(<option key={0} value={null}></option>)
          }
          for (let item of data.states) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, tenant])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (items) {
    return (
      <Input style={{ display: 'inline-block', width: 'auto' }} type="select" name="state" multiple={multiple} onChange={handleChange} defaultValue={defaultValue} >
        {items}
      </Input>
    )
  } else {
    return <Spinner />
  }
}
